const baseURL = {
  frontEnd:
    process.env.REACT_APP_ENV === "prod"
      ? "https://curorx.life"
      : process.env.REACT_APP_ENV === "beta"
      ? "https://curo-v2-beta.azurewebsites.net"
      : "http://localhost:3000",

  curoback:
    process.env.REACT_APP_ENV === "beta"
      ? "https://curo-back-v2-beta.azurewebsites.net"
      : process.env.REACT_APP_ENV === "prod"
      ? "https://curo-back-v2.azurewebsites.net"
      : "http://localhost:5000",

  docuseal: "dcosucuro-ejddbtg8h8f4e0d3.eastus-01.azurewebsites.net",
};

export const appsUrls = {
  ai: {
    url:
      process.env.REACT_APP_ENV === "prod"
        ? "https://ai.curorx.life"
        : process.env.REACT_APP_ENV === "beta"
        ? "https://ai-beta.curorx.life"
        : "http://localhost:3005",
  },
  sales: {
    url:
      process.env.REACT_APP_ENV === "prod"
        ? "https://sales.curorx.life"
        : process.env.REACT_APP_ENV === "beta"
        ? "https://sales-beta.curorx.life"
        : "http://localhost:3001",
  },
};

export default baseURL;
